var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFullBathroom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#77838D",
  d: "M6.5 18.5v-.65a.65.65 0 0 0-.636.786zm18 0 .636.136a.65.65 0 0 0-.636-.786zm-.636-.136-.653 3.047 1.272.273.653-3.048zm-4.906 6.486h-6.916v1.3h6.916zm-11.17-3.439-.652-3.047-1.272.272.654 3.048zM6.5 19.15h4v-1.3h-4zm10.5 0h3.75v-1.3H17zm3.75 0h3.75v-1.3h-3.75zm-8.708 5.7a4.35 4.35 0 0 1-4.253-3.439l-1.271.273a5.65 5.65 0 0 0 5.524 4.466zm11.17-3.439a4.35 4.35 0 0 1-4.254 3.439v1.3a5.65 5.65 0 0 0 5.525-4.466z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeWidth: 1.3,
  d: "M10.5 18a1 1 0 0 1 1-1H16a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1h-4.5a1 1 0 0 1-1-1zM23 18v-7.5c0-1-.5-3-3-3-1.6 0-2.5 1.333-2.5 2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeWidth: 1.3,
  d: "M19.5 12.5c.552 0 1.016-.46.835-.982a3 3 0 0 0-5.67 0c-.18.522.283.982.835.982h4Z"
})));
export default SvgFullBathroom;